import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { PagePath } from 'shared/constants/pagePath';
import { PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';
import { PlantItemConstants } from 'plantItemNew/constants/plantItemConstants';
import { useNavigate } from 'react-router-dom';
import { PlantItemRenewalConstants } from 'plantItemRenewal/constants/plantItemRenewalConstants';

export const PaymentCancelCallback = (props) => {
  const application = useSelector((state) => state.application);

  const navigate = useNavigate();

  useEffect(() => {
    if (application.licenceType === PlantItemConstants.licenceType) {
      navigate(PagePath.plantItemList);
    } else if (application.licenceType === PlantDesignConstants.licenceType) {
      navigate(PagePath.plantDesignReview);
    } else if (application.licenceType === PlantItemRenewalConstants.licenceType) {
      navigate(PagePath.plantItemRenewalFees);
    }
  }, []);

  return null;
};
